
import { Component } from 'vue-property-decorator';
import VOpeningHourBundle from '@/components/shared/domain/VOpeningHoursBundle.vue';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import { OpeningHour } from '@/interfaces/models/OpeningHour';
import VSpecialOpeningHour from '@/components/shared/domain/VSpecialOpeningHour.vue';

@Component({
  components: { VOpeningHourBundle, VSpecialOpeningHour },
})
export default class DeliveryHourForm extends mixins(StackedForm) {
  public $refs!: {
    specialDeliveryHour: InstanceType<typeof VSpecialOpeningHour> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: any[], overwrite?: boolean) => void;
    };
    deliveryHour: InstanceType<typeof VOpeningHourBundle> & {
      validate: () => Promise<boolean>;
      hours: OpeningHour[];
      getHours: () => OpeningHour[];
      setHours: (hours: OpeningHour[], overwrite?: boolean) => void;
    };
  };

  public deliveryHoursWeekdays: number[] = [];

  public async validate(): Promise<boolean> {
    const deliveryHours = await this.$refs.deliveryHour?.validate();
    const specialDeliveryHours = await this.$refs.specialDeliveryHour?.validate();

    return deliveryHours && specialDeliveryHours;
  }

  public getData() {
    return {
      deliveryHours: this.$refs.deliveryHour.getHours(),
      specialDeliveryHours: !!this.deliveryHoursWeekdays?.length
        ? this.$refs.specialDeliveryHour?.getHours() ?? null
        : null,
    };
  }

  public setData(data: OpeningHour[]) {
    this.$refs.deliveryHour.setHours(data, true);
  }

  public onHandledTimeSlotChange(deliveryHours: OpeningHour[]) {
    this.deliveryHoursWeekdays = (deliveryHours || []).map((oh: OpeningHour) => oh.weekday);
  }

  public mounted(): void {
    if (this.initialValues) {
      const hasDeliveryHours: boolean = !!(this.initialValues as any)?.deliveryHours?.length;
      this.onHandledTimeSlotChange((this.initialValues as any)?.deliveryHours || []);

      if (hasDeliveryHours) {
        // @ts-ignore
        this.$refs.specialDeliveryHour.setHours(this.initialValues.specialDeliveryHours);
      }

      // @ts-ignore
      this.$refs.deliveryHour.setHours(this.initialValues.deliveryHours);
    }
  }
}
